import { render, staticRenderFns } from "./EventCreate.vue?vue&type=template&id=7fd67c40&scoped=true&"
import script from "./EventCreate.vue?vue&type=script&lang=ts&"
export * from "./EventCreate.vue?vue&type=script&lang=ts&"
import style0 from "./EventCreate.vue?vue&type=style&index=0&id=7fd67c40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd67c40",
  null
  
)

export default component.exports